import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared',
  templateUrl: './shared.component.html',
  styleUrls: ['./shared.component.scss'],
  standalone: false,
})
export class SharedComponent {
  @Input()
  name!: string;
}
